<template>
  <div class="bg-white py-6 px-12">
    <p class="text-left text-xl">{{ $t("添加银行卡") }}</p>
    <div class="mt-10 grid grid-cols-[30rem,6rem] items-center">
      <div class="w-30rem form">
        <el-form
          label-position="right"
          label-width="100px"
          :model="cardMessage"
          :rules="rules"
          ref="cardForm"
        >
          <el-form-item :label="$t('姓名')" prop="name">
            <el-input
              v-model="cardMessage.name"
              :placeholder="$t('请输入姓名')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('银行卡号')" prop="cardno">
            <el-input
              v-model="cardMessage.cardno"
              :placeholder="$t('请输入银行卡号')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('开户行')" class="bank" prop="banktype_id">
            <!-- <el-input v-model="cardMessage.card_bank" class=""></el-input> -->
            <el-select
              v-model="cardMessage.banktype_id"
              :placeholder="$t('请选择开户行')"
              class="w-full"
            >
              <el-option
                v-for="item in supportBank"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('开户行信息')" prop="bankmark">
            <el-input
              v-model="cardMessage.bankmark"
              :placeholder="$t('请输入开户行信息')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('验证码')" class="code" prop="code">
            <el-input
              v-model="cardMessage.code"
              :placeholder="$t('请输入验证码')"
            >
              <template slot="append">
                <el-button>
                  <span @click="sendCode" v-if="code_show">{{
                    $t("发送验证码")
                  }}</span>
                  <span v-else>{{ $t("等待") }}{{ count }}s</span>
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="h-2rem">
        <span class="text-sm text-hex-3298F0">支持银行?</span>
      </div> -->
    </div>
    <div class="text-left pl-100px text-sm space-y-4 pt-3">
      <router-link
        :to="{ name: 'serveState', query: { tag: 'service' } }"
        class="text-hex-3298F0"
        >{{ $t("《花易宝国际服务协议》") }}</router-link
      >
      <p>
        <el-button
          type="primary"
          class="min-w-13rem text-0.9rem"
          @click="confirm"
          >{{ $t("同意协议并确定") }}</el-button
        >
      </p>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const cardMessage = ref({
      verifytype: "",
      bankmark: "",
      name: "",
      cardno: "",
      code: "",
      banktype_id: null,
    });

    //表单验证规则
    const rules = {
      name: [
        { required: true, message: ctx.root.$t("请输入姓名"), trigger: "blur" },
      ],
      cardno: [
        {
          required: true,
          message: ctx.root.$t("请输入银行卡号"),
          trigger: "blur",
        },
        {
          pattern: /^([1-9]{1})(\d{15}|\d{18})$/,
          message: ctx.root.$t("请输入正确的银行卡号"),
          trigger: "blur",
        },
      ],
      banktype_id: [
        {
          required: true,
          message: ctx.root.$t("请选择开户行"),
          trigger: "change",
        },
      ],
      bankmark: [
        {
          required: true,
          message: ctx.root.$t("请输入开户行信息"),
          trigger: "blur",
        },
      ],

      code: [
        {
          required: true,
          message: ctx.root.$t("请输入验证码"),
          trigger: "blur",
        },
        {
          pattern: /^-?\d+\.?\d*$/,
          message: ctx.root.$t("请输入正确的数据"),
          trigger: "blur",
        },
      ],
    };
    //获取开户行

    const supportBank = ref();
    onMounted(async () => {
      const res = await ctx.root.$lazy("datadic");
      supportBank.value = res.banktype;
      const checkedCard = ctx.root.$route.query.item;

      if (checkedCard) {
        cardMessage.value.name = checkedCard.name;
        cardMessage.value.bankmark = checkedCard.bankmark;
        cardMessage.value.banktype_id = checkedCard.banktype.id;
        cardMessage.value.cardno = checkedCard.cardno;
        cardMessage.value.banktype = checkedCard.banktype;
        cardMessage.value.id = checkedCard.id;
      }
    });
    //获取用户信息
    const user = computed(() => ctx.root.$store.getters.user);
    //发送手机验证码
    const code_show = ref(true);
    const count = ref(Number(0));
    const whenSendcode_phone = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      code_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count.value = countDown;
      const timer = setInterval(() => {
        if (count.value > 0 && count.value <= 60) {
          count.value--;
        } else {
          code_show.value = true;
          clearInterval(timer);
        }
      }, 1000);
    };

    const sendCode = async () => {
      if (user.value.phone) {
        cardMessage.value.verifytype = "phone";
        const res = await ctx.root.$callapi("sendVerifyPhone", {
          phone: user.value.phone,
          usetype: "bind",
        });
        if (res && res.code == 0) {
          whenSendcode_phone();
        }
      } else {
        cardMessage.value.verifytype = "email";
        const res = await ctx.root.$callapi("sendVerifyEmail", {
          email: user.value.email,
          usetype: "bind",
        });
        if (res && res.code == 0) {
          whenSendcode_phone();
        }
      }
    };
    //确认绑定银行卡
    const confirm = () => {
      ctx.refs.cardForm.validate(async (valid) => {
        if (valid) {
          ctx.root.$doing();
          const res = await ctx.root.$callapi(
            "user/saveBankCard",
            cardMessage.value
          );
          ctx.root.$done();
          if (res.code == 0) {
            ctx.root.$toast(ctx.root.$t("保存成功"), "success");
            ctx.root.$router.go(-1);
          }
        } else {
          return false;
        }
      });
    };
    return {
      cardMessage,
      rules,
      supportBank,
      confirm,
      code_show,
      count,
      sendCode,
    };
  },
};
</script>
<style scoped lang="scss">.form ::v-deep .el-input__inner {
  height: 2.8rem;
}
.form ::v-deep .el-form-item {
  margin-bottom: 1.25rem;
}
.form ::v-deep .el-form-item__label {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}</style>
